
import * as React from "react";
import { List, Datagrid, Edit, SimpleForm, TextField, EditButton, TextInput,
    ReferenceField, BooleanField, BooleanInput, useTranslate } from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";

// Entity
const entity = "affiliateForm";

export const AffiliateFormList = (props) => {
    const translate = useTranslate();
    return (
        <List {...props} empty={<EmptyList entity={entity} />} title={translate('affiliateForm.title', { _: 'Affiliate Başvuruları' })} exporter={false}>
            <Datagrid>
                <TextField source="name" label={translate('affiliateForm.app_name', { _: 'Başvuru Sahibi Adı' })} />
                <TextField source="surname" label={translate('affiliateForm.app_surname', { _: 'Başvuru Sahibi Soyadı' })} />
                <ReferenceField source="user" reference="users" label={translate('affiliateForm.user', { _: 'Kullanıcı' })}>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="user" reference="users" label={translate('affiliateForm.user_mobile', { _: 'Kullanıcı Telefonu' })}>
                    <TextField source="mobile" />
                </ReferenceField>
                <BooleanField source="isChecked" label={translate('affiliateForm.checked', { _: 'İncelendi mi?' })} />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const AffiliateFormEdit = (props) => {
    const translate = useTranslate();
    return (
        <Edit title={translate('affiliateForm.edit_title', { _: 'Başvuruyu İncele / Düzenle' })} {...props}>
            <SimpleForm redirect={`/${entity}`}>

                <h2>{translate('affiliateForm.actions', { _: 'İşlemler' })}</h2>
                <BooleanInput source="isChecked" label={translate('affiliateForm.checked', { _: 'İncelendi mi?' })} />
                <TextInput source={'notes'} label={translate('affiliateForm.notes', { _: 'Notlar' })} fullWidth multiline rows={3} />

                <h2>{translate('affiliateForm.details', { _: 'Başvuru Detayları' })}</h2>
                <TextInput source="name" label={translate('users.name', { _: 'Ad' })} fullWidth disabled />
                <TextInput source="surname" label={translate('users.surname', { _: 'Soyad' })} fullWidth disabled />
                <TextInput source="facebook" label={"Facebook"} fullWidth disabled />
                <TextInput source="instagram" label={"Instagram"} fullWidth disabled />
                <TextInput source="twitter" label={"Twitter"} fullWidth disabled />
                <TextInput source="tiktok" label={"TikTok"} fullWidth disabled />
            </SimpleForm>
        </Edit>
    );
};
